import React from "react";
import { EvtStatsCard as StatsCard } from "components/stats/display-card";
import { EvtStatsCardLoader } from "components/stats/loader";
import { DisplayAmount } from "components/display/amount";
import { useCollectedBilling } from "../hooks/useCollectedBilling";
import { useRevenuePercentage } from "../hooks/useRevenuePercentage";
import { useMoMGrowth } from "../hooks/useMoMGrowth";
import { useJobsCount } from "../hooks/useJobsCount";

const renderAmount = (amount) => {
  return <DisplayAmount value={amount} />;
};

const renderPercentage = (percentage) => {
  return `${percentage.toFixed(1)}%`;
};

export const ExpectedBillingCard = ({ jobType, filters }) => {
  const { data: collectedBilling, isLoading } = useCollectedBilling(
    jobType,
    filters
  );

  if (isLoading) {
    return <EvtStatsCardLoader />;
  }

  return (
    <StatsCard
      label="Collected Billing"
      value={renderAmount(collectedBilling || 0)}
    />
  );
};

export const RevenuePercentageCard = ({ jobType, filters }) => {
  const { data: revenueData, isLoading } = useRevenuePercentage(
    jobType,
    filters
  );

  if (isLoading) {
    return <EvtStatsCardLoader />;
  }

  const typeLabel = jobType.charAt(0).toUpperCase() + jobType.slice(1);

  return (
    <StatsCard
      label={`% Contribution to Total`}
      value={renderPercentage(revenueData?.revenuePercentage || 0)}
    />
  );
};

export const MoMGrowthCard = ({ jobType, filters }) => {
  const { data: growthData, isLoading } = useMoMGrowth(jobType, filters);

  if (isLoading) {
    return <EvtStatsCardLoader />;
  }

  return (
    <StatsCard
      label="MOM Growth"
      value={renderAmount(growthData?.momGrowthAmount || 0)}
      difference={growthData?.momGrowthPercentage}
    />
  );
};

export const JobsCountCard = ({ jobType, filters }) => {
  const { data: jobsCount, isLoading } = useJobsCount(jobType, filters);

  if (isLoading) {
    return <EvtStatsCardLoader />;
  }

  const typeLabel = jobType.charAt(0).toUpperCase() + jobType.slice(1);

  return (
    <StatsCard label={`No. of ${typeLabel} Jobs`} value={jobsCount || 0} />
  );
};
